/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, provideZonelessChangeDetection, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from './components/components.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbTimepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';

import { environment } from '../environments/environment';

//Auth
import { AuthGuard } from './auth/auth-guard.service';
import { RedirectGuard } from './_guards/redirect.guard';
import { RoleGuard, DesktopGuard, MobileGuard } from './_guards/role.guard';
import { GameGuard } from './_guards/game.guard';
import { AuthService } from './auth/auth-service.service';
import { UserService, SubscriberService, LanguageService, ThemeService, CityService, GameService, TemplateService, 
  MediaService, MissionService, ObjectService, ResourceService, BuildingService, RoleService, CharacterService, PlayerService, JournalService,
  TeamService, GroupService,
  GeocodingService, PoiService, DiagramService, StatService, TicketService, VoucherService, 
  SmsService, AIService } from './_services/index';

  import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
  import { provideAuth, getAuth, initializeAuth, indexedDBLocalPersistence } from '@angular/fire/auth';
  import { provideFirestore, getFirestore } from '@angular/fire/firestore';
  import { provideStorage, getStorage } from '@angular/fire/storage';

//Translations
import {TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';

//Rich text editor
import { QuillModule } from 'ngx-quill';

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        AppRoutingModule,
        ThemeModule.forRoot(),
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbTimepickerModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        NbChatModule.forRoot({
            messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
        }),
        CoreModule.forRoot(),
        ComponentsModule,
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix:".json"})
        }),
        QuillModule.forRoot({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'font': [] }],
                    ['link', 'image', 'video'],
                    ['clean']
                ]
            }
        })], 
    providers: [
        //provideZonelessChangeDetection(), 
        provideZoneChangeDetection(),
        { provide: APP_BASE_HREF, useValue: '/' },
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        provideStorage(() => getStorage()),
        AuthService, AuthGuard, RedirectGuard, RoleGuard, DesktopGuard, MobileGuard, GameGuard,
        UserService, SubscriberService, LanguageService, ThemeService, CityService, GameService, TemplateService,
        MediaService, MissionService, ObjectService, ResourceService, BuildingService, RoleService, CharacterService, PlayerService,
        JournalService, GeocodingService, PoiService, DiagramService, StatService,
        TeamService, GroupService,
        TicketService, VoucherService, SmsService, AIService,
        Title,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
